<template>
    <transition name="fade">
        <div
            class="modal"
            :class="value ? 'show' : 'hide'"
            :style="value ? 'display:block;background-color:#3333337a;' : 'display:none;'"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
        >
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header d-flex flex-row align-items-center">
                    <h3>
                        Commande #{{ row_no.no_id }}
                    </h3>
                </div>
                <div class="modal-body">

                    <div v-if="editionMode" class="row">
                        <div class="col col-lg-7">
                            <h4>Mettre à jour le statut</h4>

                            <m-form-select
                                label="Nouveau statut"
                                label-position="top"
                                v-model="status"
                                :items="$store.state.items_no_statuses"
                            />

                            <div v-if="status !== 'ORDER_SENT'">
                                <m-form-text 
                                    :rows="8"
                                    label="Commentaire"
                                    type="textarea"
                                    v-model="comment"
                                />
                                <div v-if="commentError" class="text-danger">{{ commentError }}</div>
                            </div>

                            <div v-else>

                                <m-form-date
                                    label="Date de l'envoi"
                                    v-model="pa_date"
                                />

                                <m-form-select
                                    label="Société de Livraison"
                                    v-model="pa_company"
                                    :items="$store.state.items_company"
                                />

                                <m-form-text
                                    label="N° de suivi"
                                    type="text"
                                    v-model="pa_trackingcode"
                                />
                            </div>

                        </div>
                        <!--div class="col col-lg-5">

                            <h4>Réponses prédéfinies</h4>

                            <ul >
                                <li v-for="(message, index) in predefinedMessagesList" :key="index" @click="setPredefinedMessages(message.key)">
                                    {{ message.description }}
                                </li>
                            </ul>

                        </div-->
                    </div>
                    
                    <div v-else class="row">

                        <div class="col-12 col-lg-6">

                            <h4>Information</h4>
                            <table class="table table-sm">
                                <tbody>
                                    <!--tr>
                                        <td class="text-right no_label_cell">Commande du&nbsp;:</td>
                                        <td>
                                            <span>
                                                {{ $moment(row_no.createdAt).format("DD/MM/YYYY HH:mm") }}
                                            </span>
                                        </td>
                                    </tr-->
                                    <tr>
                                        <td class="text-right no_label_cell">Contact&nbsp;:</td>
                                        <td>
                                            <a href="javascript: void" @click="goToContactDetails">
                                                {{ row_no.co_id.co_invoice_firstname }} {{ row_no.co_id.co_invoice_name }}
                                            </a>
                                            <div>
                                                <small>
                                                    <a :href="$Utils.formatPhoneNumber(row_no.co_id.co_invoice_tel, row_no.co_id.co_invoice_country).getURI()">
                                                        {{ $Utils.formatPhoneNumber(row_no.co_id.co_invoice_tel, row_no.co_id.co_invoice_country).formatInternational() }}
                                                    </a>
                                                </small>
                                            </div>
                                            <div>
                                                <small>
                                                    <a :href="`mailto:${row_no.co_id.co_invoice_email}`">
                                                        {{ row_no.co_id.co_invoice_email }}
                                                    </a>
                                                    </small>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right no_label_cell">Bénéficiaire&nbsp;:</td>
                                        <td>
                                            <a href="javascript: void" @click="goToBoxDetails">
                                                {{ row_no.en_id ? row_no.en_id.en_fullname : "---" }}
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right no_label_cell">
                                            Statut&nbsp;:
                                        </td>
                                        <td>
                                            {{ getOrderStatus(row_no.no_status) }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right no_label_cell">
                                            Mis à jour le&nbsp;:
                                        </td>
                                        <td>
                                            {{ $moment(row_no.no_status_date).format("DD/MM/YYYY HH:mm") }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                        <div class="col-12 col-lg-6">
                            <h4>Suivi de la commande</h4>
                            <table class="table table-sm">
                                <tbody>
                                    <tr v-for="(item, index) in row_no.no_history.list" :key="index">
                                        <td class="no_label_cell">
                                            {{ $moment(item.date).format("DD/MM/YYYY HH:mm") }}
                                        </td>
                                        <td>
                                            {{ getOrderStatus(item.status) }}
                                            <p v-if="item.comment">
                                               <i><pre>{{ item.comment }}</pre></i>
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                  
            
                </div>
                <div class="modal-footer">

                    <div v-if="editionMode">
                        <button type="button" class="btn btn-secondary" @click="cancelEditStatus">Annuler</button>
                        <button type="button" class="btn btn-primary ml-2" @click="updateStatus">Mettre à jour</button>
                    </div>
                    <div v-else>
                        <button type="button" class="btn btn-secondary" @click="cancelWin">Fermer</button>
                        <button type="button" class="btn btn-primary ml-2" @click="editStatus">Modifier</button>
                    </div>


                </div>
            </div>
        </div>
        <m-message-dialog v-model="dialogErr" title="Erreur" :text="dialogErrTxt"></m-message-dialog>
        </div>
    </transition>
</template>

<script>
export default {
    name: "cancellationWinEdit",

    components: {},

    props: {
        value: {
            default: false,
            type: Boolean
        },

        row_no_p: {
            default: null,
            type: Object
        }
    },

    data() {
        return {
            row_no: {
                co_id: {},
                en_id: {},
                no_id: undefined,
                no_history: {list: []},
            },
            status: '',
            comment: '',
            commentError: '',

            pa_date: this.$moment().format("YYYY-MM-DD"),
            pa_state: "",
            pa_company: "",
            pa_trackingcode: "",

            editionMode: false,
            dialogCancellation: false,
            dialogErrTxt: "",
            dialogErr: false,
            predefinedMessages: {
                RDV: {
                    content: "",
                    description: ""
                },
            }
        };
    },

    computed: {
        predefinedMessagesList() {
            return Object.keys(this.predefinedMessages).map(key => ({
                key,
                description: this.predefinedMessages[key].description
            }));
        }
    },

    mounted() {
        this.user = this.$store.state.user;
        window.addEventListener("keyup", this.onKeyup);
    },

    destroyed() {
        window.removeEventListener("keyup", this.onKeyup);
    },

    created() {},

    watch: {
        row_no_p(value) {
            this.row_no = value;
        }
    },

    methods: {

        onKeyup(e) {
            if (e.key === "Escape") {
                this.cancelWin();
            }
        },

        goToContactDetails() {
            this.$router.push(`/contacts/${this.row_no.co_id.co_id}/details`);
            this.$emit("input", false);
        },
       

        goToBoxDetails() {
            this.$router.push(`/boxes/${this.row_no.en_id.en_id}`);
            this.$emit("input", false);
        },

        getOrderStatus(value) {
            const result = this.$store.state.items_no_statuses.find(status => status.value === value);
            return result ? result.text : "???";
        },

        editStatus() {
            this.editionMode = true;
        },

        cancelEditStatus() {
            this.editionMode = false;
        },

        setPredefinedMessages(key) {
            const predefinedMessage = this.predefinedMessages[key];
            if(predefinedMessage) {
                this.comment = predefinedMessage.content;
                this.attachment = predefinedMessage.attachment || "";
            }
        },

        async updateStatus() {
            
            if(!this.status) {
                return
            }

            const comments_required = {
                PAYMENT_PENDING: 0,
                PAYMENT_DONE: 0,
                ORDER_DELAYED: 1,
                ORDER_SENT: 0,
                ORDER_DELIVERED: 0,
            }

            if(comments_required[this.status] && this.comment.length === 0) {
                this.commentError = "un commentaire est requis pour ce statut";
                return;
            } else {
                this.commentError = "";
            }

            let payload = {
                no_id: this.row_no.no_id,
                no_status: this.status,
                no_status_comment: this.comment
            }

            if(this.status === "ORDER_SENT") {
                payload = {
                    ...payload,
                    pa_date: this.pa_date,
                    pa_company: this.pa_company,
                    pa_trackingcode: this.pa_trackingcode
                }
            }

            const response = await this.$axios.put(`${this.$config.server_url}/extranet/2.0/newOrder/${this.row_no.no_id}`, payload);

            this.editionMode = false;

            this.comment = "";
            this.status = "";

            if (response.data.err) {
                this.$store.dispatch("showDialogError", response.data.err.message);
                return;
            }

            this.row_no = {
                ...this.row_no,
                no_status: response.data.row_no.no_status,
                no_status_comment: response.data.row_no.no_status_comment,
                no_status_date: response.data.row_no.no_status_date,
                no_history: response.data.row_no.no_history
            }
    
            this.$emit("reload", false);
        },
        cancelWin() {
            this.comment = "";
            this.status = "";
            this.attachment = "";
            this.$emit("input", false);
        }
    }
};
</script>

<style scoped lang="scss">
    @import "../scss/styles.scss";

    .table {
        table-layout: fixed;
    }

    .table tr:nth-child(odd) {
        background-color: inherit;
    }

    .table tr:hover {
        background-color: inherit;
        cursor: inherit;
    }

    .table tr td {
        border: 0;
    }

    .no_label_cell {
        width: 160px;
        font-weight: 500;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin-bottom: 3px;
        padding: 2px 4px;
        width: 100%;
        cursor: pointer;
        border: 1px solid #c0c0c0;
        border-radius: 3px;
    }

    li:hover {
        background-color: #f5f5f5
    }

    pre {
        white-space: break-spaces;
    }
</style>
